export interface ProductStepComponentInput {
  hideGlutenFree?: boolean;
}

export interface TicketStepComponentInput {
  showWarning?: boolean;
}

